/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button } from '@atoms';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { ConfirmModal, UploadCSVModal } from '@organisms';
import { useUploadCSVSocialMedia } from '../api/upload-social-links';
import { errorMessage, successMessage } from '@services';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useModalState } from '@hooks';
import { Typography } from '@mui/material';

const UploadButton = () => {
  const { assetId } = useParams();
  const [openUploadCSVModal, setOpenUploadCSVModal] = useState<boolean>(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [duplicatedLinks, setDuplicatedLinks] = useState<string[]>([]);
  const [showDuplicatedModal, , openDuplicatedModal, closeDuplicatedModal] = useModalState(false);

  const uploadCSVSocialMediaMultation = useUploadCSVSocialMedia({
    mutationConfig: {
      onSuccess: (data) => {
        if (!data.data?.duplicatedLinksCount) {
          successMessage('CSV file has been uploaded successfully!');
          setUploadSuccess(true);
          setOpenUploadCSVModal(false);
          return;
        }

        setDuplicatedLinks(data.data?.existingItems || []);
        openDuplicatedModal();

        if (data.data?.savedLinks.length) {
          successMessage('CSV file has been uploaded successfully!');
          setUploadSuccess(true);
          setOpenUploadCSVModal(false);
        }
      },
      onError: () => {
        setOpenUploadCSVModal(false);
        setUploadSuccess(true);
        errorMessage('CSV file upload failed!');
      },
    },
  });

  const handleUploadCSV = async (file: File) => {
    if (!assetId) return;
    uploadCSVSocialMediaMultation.mutate({
      data: file,
      modelId: assetId,
    });
  };

  useEffect(() => {
    if (uploadSuccess) {
      setUploadSuccess(false);
    }
  }, [uploadSuccess]);

  const onClickOpenCSVModal = () => setOpenUploadCSVModal(true);

  const onClickCloseCSVModal = () => setOpenUploadCSVModal(false);

  return (
    <>
      <Button
        variant="text"
        color="black"
        startIcon={<PostAddIcon />}
        onClick={onClickOpenCSVModal}
      >
        By CSV
      </Button>
      <UploadCSVModal
        open={openUploadCSVModal}
        onCancel={onClickCloseCSVModal}
        onConfirm={handleUploadCSV}
        loading={uploadCSVSocialMediaMultation.isLoading}
        uploadSuccess={uploadSuccess}
      />
      <ConfirmModal
        open={showDuplicatedModal}
        submitText="Understand"
        usingModalV2
        sxButtonCancel={{ display: 'none' }}
        onCancel={closeDuplicatedModal}
        onSubmit={closeDuplicatedModal}
        title={
          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: '24px',
              color: '#FF4848',
              whiteSpace: 'normal',
            }}
          >
            Your CSV contains duplicated links with existed ones in the system.
            <br />
            Please check the list below.
            <br />
            {duplicatedLinks.map((link, index) => (
              <Typography
                key={link}
                sx={{
                  color: '#000000',
                  whiteSpace: 'normal',
                  display: 'block',
                  textAlign: 'left',
                }}
              >
                {index + 1}. {link}
              </Typography>
            ))}
          </Typography>
        }
      />
    </>
  );
};
export default UploadButton;
